import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';

const NotFoundPage = () => (
  <section className="bg-white section">
    <SEO title="Page not found" path="/404" />
    <div className="max-w-3xl mx-auto text-center">
      <div className="text-xs uppercase tracking-[0.2em] text-ink-3 mb-5">404</div>
      <h1 className="headline-lg text-ink mb-6">This page can’t be found.</h1>
      <p className="text-ink-2 mb-8">The link may have moved, or it may never have existed.</p>
      <Link to="/" className="btn-primary">Back home <ArrowRight className="w-4 h-4" /></Link>
    </div>
  </section>
);

export default NotFoundPage;
